export const channels = [
  {
    name: "Channel 1",
    component: "ChannelOne",
    path: "channel1"
  },
  {
    name: "Channel 2",
    component: "Messenger",
    path: "messenger"
  },
  {
    name: "Channel 3",
    component: "ChannelThree",
    path: "channel3"
  }
];
